import React from 'react';

import ImportInstrumentDataModal from 'instruments/instrument-data/ImportInstrumentDataModal';
import {ClientAutomationOutputFileConfigSpec} from 'lab-automation/settings/RunSchemaSpecConstants';

import * as SpreadsheetBulkImportActions from '../SpreadsheetBulkImportActions';
import {PaneKey} from '../SpreadsheetBulkImportConstants';

interface Props {
  nextPaneKey: PaneKey;
  connectionSchemaId?: string;
  delimiter: string;
  automationOutputFileConfig: ClientAutomationOutputFileConfigSpec;
  modalProps: {
    title: string;
    onRequestClose: () => void;
  };
  shouldShowUploadedFilesOnly?: boolean;
}

export default function ImportInstrumentDataModalPane(props: Props): JSX.Element {
  return (
    <ImportInstrumentDataModal
      connectionSchemaId={props.connectionSchemaId}
      onRequestSubmit={(instrumentData) => {
        SpreadsheetBulkImportActions.uploadAndParseInstrumentData(instrumentData[0], props.delimiter);
        SpreadsheetBulkImportActions.goToPaneWithKey(props.nextPaneKey);
      }}
      allowMultiple={false}
      onRequestClose={props.modalProps.onRequestClose}
      automationOutputFileConfig={props.automationOutputFileConfig}
      shouldShowUploadedFilesOnly={props.shouldShowUploadedFilesOnly}
    />
  );
}
